import { call, put, all, takeLatest } from 'redux-saga/effects';

import { getTabsDataWithParams } from '../../../services/posPagamento';
import { loadTabsConsultaPosPagamentoSuccess} from './actions';

function* loadTabsConsultaPosPagamentoRequest(IdContrato, IdMenu) {
  const tabs = yield call(getTabsDataWithParams, IdContrato, IdMenu  );

  yield put(loadTabsConsultaPosPagamentoSuccess(tabs));
}

export default all([
  takeLatest('@posPagamentoContrato/LOAD_TABS_CONSULTA_REQUEST', loadTabsConsultaPosPagamentoRequest),
]);
